import Vue from "vue";
import Vuex from "vuex";
import { bandeauModeration } from "./assets/js/idyu/util";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: null,
    user: null,
    data: null,
    loading: false,
    lang: 0,
    iconTheme: "grey",
    showVersion: "no",
    lastContact: null,
    lastSearch: null,
    lastResultIndex: -1,
    windowWidth: 0,
    videoStream: null,
    messager: null,
    siteConst: {
      passName: "Pass Idylive",
      name: "Idylive",
      addressName: "Idylive",
      firstNamePart: "Idy",
      secondNamePart: "live",
      coloredName: "<b><span class='black'>Idy</span><span class='pinklive'>live</span></b>"
    },
    friendList: null,
    needsReload: false,
    bandeau: 0,
    passLinkType: 0,
    showBandeau: true,
    promo: null
  },

  mutations: {
    updateBandeau(state) {
      const mod = bandeauModeration(state.profile);
      if (mod) {
        state.bandeau = mod;
      } else {
        state.bandeau = state.passLinkType;
      }
    },

    setBandeau(state, val) {
      state.bandeau = val;
    },

    setPassLinkType(state, val) {
      state.passLinkType = val;
    },

    setLoading: function(state, val) {
      state.loading = val;
    },

    setProfile(state, val) {
      state.profile = val;
    },

    setData(state, val) {
      state.data = val;
    },

    setUser(state, val) {
      state.user = val;
    },

    setIconTheme(state, val) {
      state.iconTheme = val;
    },

    setShowVersion(state, val) {
      state.showVersion = val;
    },

    setLastSearch(state, val) {
      state.lastSearch = val;
    },

    setLastResultIndex(state, val) {
      state.lastResultIndex = val;
    },

    setMessager(state, val) {
      state.messager = val;
    }
  },

  actions: {}
});
